import React, { useState, useEffect } from "react";
import { InputSwitch } from "primereact/inputswitch";
import "./settings.css";
const Row = ({ label, children }) => (
  <div className="row align-items-center form-row">
    <div className="col-12 col-md-3 col-lg-2 tab-view">{label}</div>
    <div className="col-12 col-md-5 col-lg-4 control-col">{children}</div>
  </div>
);

const InfoRow = ({ label, children, title }) => (
  <div className="row align-items-center form-row">
    <div className="col-12 col-md-3 col-lg-2 tab-view">{label}</div>
    <div className="col-12 col-md-5 col-lg-4 position-relative">
      {children}
      <div
        style={{
          position: "absolute",
          top: "50%",
          right: "-12px",
          transform: "translateY(-50%)",
        }}
      >
        <i className="fa fa-info-circle fa-lg text-secondary" title={title} />
      </div>
    </div>
  </div>
);
const Settings = ({ question, questionList, onChange }) => {
  if (!question) return <div></div>;

  const dropDownOptions = [
    { label: "Randomized", value: "random" },
    { label: "Ascending", value: "ascending" },
    { label: "Descending", value: "descending" },
    { label: "Normal", value: "normal" },
  ];

  const ratingOptionsDropDown = [3, 5, 7].map((n) => ({ label: n, value: n }));
  const webOptionsDropDown = [3, 2, 1].map((n) => ({ label: n, value: n }));
  const mobileOptionsDropDown = [2, 1].map((n) => ({ label: n, value: n }));

  const allQuestions =
    questionList?.flatMap((p) => p.elements || []) || [];

  const activeIndex = allQuestions.findIndex((q) => q.id === question.id);

  const optionPipelineQuestions =
    activeIndex >= 0
      ? allQuestions.slice(0, activeIndex).filter(
          (q) =>
            q.type === "checkbox" &&
            (!q.option_piping || q.option_piping === "")
        )
      : [];

  const renderSelect = (value, field, list) => (
    <select
      className="form-select form-select-md"
      value={value}
      onChange={(e) => onChange(e.target.value, field, question)}
    >
      {list.map((opt) => (
        <option key={opt.value} value={opt.value}>
          {opt.label}
        </option>
      ))}
    </select>
  );

  const renderNumericInput = (field) => (
    <input
      type="number"
      className="form-control form-control-md"
      value={question[field] ?? ""}
      onChange={(e) => onChange(e, field, question)}
    />
  );

  // ======================
  // TYPE SPECIFIC BLOCKS
  // ======================
  const type = question.type;

  const switches = (
    <>
      <Row label="Other">
        <InputSwitch
          checked={!!question.others}
          onChange={(e) => onChange(e, "others", question)}
        />
      </Row>

      <Row label="None">
        <InputSwitch
          checked={!!question.none}
          onChange={(e) => onChange(e, "none", question)}
        />
      </Row>

      <Row label="Coded Option">
        <InputSwitch
          checked={!!question.codedOption}
          onChange={(e) => onChange(e, "codedOption", question)}
        />
      </Row>

      <Row label="Is Randomized">
        {renderSelect(question.choicesOrder ?? "normal", "choicesOrder", dropDownOptions)}
      </Row>

      <InfoRow label="Web Options" title="How options display on Web">
        {renderSelect(question.webOptions ?? 3, "webOptions", webOptionsDropDown)}
      </InfoRow>

      <InfoRow label="Mobile Options" title="How options display on Mobile">
        {renderSelect(question.mobileOptions ?? 2, "mobileOptions", mobileOptionsDropDown)}
      </InfoRow>
    </>
  );

  return (
    <div>
      {/* Code */}
      <Row label="Code">
        <input
          name="tempId"
          className="form-control form-control-md"
          value={question.tempId || ""}
          onChange={(e) => onChange(e, "tempId", question)}
        />
      </Row>

      {/* Mandatory */}
      <Row label="Is Mandatory">
        <InputSwitch
          checked={!!question.isMandatory}
          onChange={(e) => onChange(e, "isMandatory", question)}
        />
      </Row>

      {/* TYPE SPECIFIC */}
      {type === "radiogroup" && switches}

      {type === "checkbox" && (
        <>
          {switches}

          <Row label="Other Count">
            <input
              type="number"
              min={1}
              disabled={!question.others}
              className="form-control form-control-md"
              value={question.otherNumber || ""}
              onChange={(e) => onChange(e, "otherNumber", question)}
            />
          </Row>

          <Row label="Option Pipeline">
            <select
              className="form-select form-select-md"
              value={question.option_pipeline ?? ""}
              onChange={(e) =>
                onChange(e.target.value, "option_pipeline", question)
              }
            >
              <option value="">Select Option Pipeline</option>
              {optionPipelineQuestions.map((q) => (
                <option key={q.id} value={q.id}>
                  {q.tempId} - {q.questionText}
                </option>
              ))}
            </select>
          </Row>

          {question.option_pipeline && (
            <Row label="Option Mode">
              {renderSelect(
                question.option_pipeline_type ?? "include",
                "option_pipeline_type",
                [
                  { label: "Include", value: "include" },
                  { label: "Exclude", value: "exclude" },
                ]
              )}
            </Row>
          )}
        </>
      )}

      {type === "numeric" && (
        <>
          <Row label="Min Value">{renderNumericInput("minValue")}</Row>
          <Row label="Max Value">{renderNumericInput("maxValue")}</Row>

          <Row label="Place Holder Text">
            <textarea
              className="form-control form-control-md"
              rows={1}
              value={question.placeHolderText || ""}
              onChange={(e) => onChange(e, "placeHolderText", question)}
            />
          </Row>
        </>
      )}

      {(type === "rating" || type === "starRating") && (
        <Row label="Maximum Rating">
          {renderSelect(question.rateMax ?? 5, "rateMax", ratingOptionsDropDown)}
        </Row>
      )}

      {type === "openText" && (
  <Row label="Place Holder Text">
    <textarea
      className="form-control form-control-md"
      rows={1}
      value={question.placeHolderText || ""}
      onChange={(e) => onChange(e, "placeHolderText", question)}
    />
  </Row>
)}

{type === "multiText" && (
  <>
    {/* Placeholder */}
    <Row label="Place Holder Text">
      <textarea
        className="form-control form-control-md"
        rows={1}
        value={question.placeHolderText || ""}
        onChange={(e) => onChange(e, "placeHolderText", question)}
      />
    </Row>

    {/* NEW: IsOption Toggle */}
    <Row label="Is Option">
      <InputSwitch
        checked={!!question.isOption}
        onChange={(e) => onChange(e, "isOption", question)}
      />
    </Row>

    {/* NEW: Option Pipeline (same as checkbox) */}
    <Row label="Option Pipeline">
      <select
        className="form-select form-select-md"
        value={question.option_pipeline ?? ""}
        onChange={(e) =>
          onChange(e.target.value, "option_pipeline", question)
        }
      >
        <option value="">Select Option Pipeline</option>
        {optionPipelineQuestions.map((q) => (
          <option key={q.id} value={q.id}>
            {q.tempId} - {q.questionText}
          </option>
        ))}
      </select>
    </Row>

    {/* NEW: Option Mode */}
    {question.option_pipeline && (
      <Row label="Option Mode">
        {renderSelect(
          question.option_pipeline_type ?? "include",
          "option_pipeline_type",
          [
            { label: "Include", value: "include" },
            { label: "Exclude", value: "exclude" },
          ]
        )}
      </Row>
    )}
  </>
)}

      

      {["ranking", "singleDropdown", "multiselectdropdown", "imagepicker"].includes(
        type
      ) && (
        <Row label="Is Randomized">
          {renderSelect(question.choicesOrder ?? "normal", "choicesOrder", dropDownOptions)}
        </Row>
      )}

      {type === "sliderScale" && (
        <>
          {["minValue", "maxValue", "step"].map((field) => (
            <Row key={field} label={field.replace(/^\w/, (c) => c.toUpperCase())}>
              {renderNumericInput(field)}
            </Row>
          ))}
        </>
      )}

      {type === "NPS" && (
        <>
          <Row label="Minimum Label">
            <input
              className="form-control form-control-md"
              value={question.minLabel || ""}
              onChange={(e) => onChange(e, "minLabel", question)}
            />
          </Row>
          <Row label="Maximum Label">
            <input
              className="form-control form-control-md"
              value={question.maxLabel || ""}
              onChange={(e) => onChange(e, "maxLabel", question)}
            />
          </Row>
        </>
      )}

      {/* Common Error Text */}
      <Row label="Error Text">
        <textarea
          className="form-control form-control-md"
          rows={1}
          value={question.requiredErrorText || ""}
          onChange={(e) => onChange(e, "requiredErrorText", question)}
        />
      </Row>
    </div>
  );
};

export default Settings;
